import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@ts-digital/vrc";
import "./style.css";

class Table extends React.PureComponent {

  constructor(){
    super();
    this.state = {
      checkAll: false,
      checked: [],
      checkAllIndeterminate: false
    };
  }

  onCheckAll(checked){
    let selected = [];
    if (checked) {
      this.props.dataSource.map(item => {
        return selected.push(item.id);
      });
    }
    this.setState({ checkAll: checked, checked: selected, checkAllIndeterminate: false });
    if (this.props.onSelect){
      this.props.onSelect(selected);
    }
  }

  onCheck(
    id, checked, selectedRows
  ){
    let selected = selectedRows;
    if (selectedRows.lenght > 0){
      selected = this.state.checked;
    }

    if (checked) {
      if (selected.indexOf(id) < 0){
        selected.push(id);
      }
    } else {
      if (selected.indexOf(id) > -1){
        selected.splice(selected.indexOf(id), 1);
      }
    }
    this.setState({ checkAll: selected.length === this.props.dataSource.length, checked: selected, checkAllIndeterminate: selected.length > 0 && selected.length < this.props.dataSource.length });
    if (this.props.onSelect){
      this.props.onSelect(selected);
    }
    this.forceUpdate();
  }

  renderContent(
    accordionContent,
    accordionIndexOpen,
    columns,
    dataSource,
    emptyMessage,
    additionalProps,
    selection,
    bodyHeight,
    selectedRows
  ) {

    let arrayCeils = [];
    let arrayRows = [];
    // ciclo le righe
    for (let r = 0; r < dataSource.length; r++) {
      // reset celle ad ogni ciclo altrimenti avrei colonne moltiplicate per le righe = casino
      arrayCeils = [];
      // ciclo le colonne
      if (selection){
        arrayCeils.push(<td className="cell" key={"cellTbody_" + r}>
          <Checkbox checked={selectedRows.length > 0 ? this.state.checked.indexOf(dataSource[r].id) > -1 : selectedRows.indexOf(dataSource[r].id) > -1} onChange={(checked) => this.onCheck(
            dataSource[r].id, checked, selectedRows
          )}></Checkbox>
        </td>);
      }
      for (let c = 0; c < columns.length; c++) {
        let recoverValue;
        // devo renderizzare un nodo complesso che ho definito nel mio config
        if (columns[c].renderCustom) {
          recoverValue = columns[c].renderCustom(dataSource[r]);
        } else {
          // renderizzo del "semplice" testo
          /** è una function se non riesco a recuperare in modo semplice, esempio nei metadati ho un array e devo cercare il value del name */
          recoverValue =
            typeof columns[c].dataKey === "function"
              ? columns[c].dataKey(dataSource[r], additionalProps)
              : dataSource[r][columns[c].dataKey];
        }
        arrayCeils.push(<td className="cell" key={"cellTbody_" + r + "_" + c} style={columns[c].style}>
          {recoverValue}
        </td>);
      }
      arrayRows.push(<tr className="row" key={"row_" + r} data-index={r}>
        {arrayCeils}
      </tr>);
      arrayRows.push(<tr className="row hiddenContent" key={"hiddenRow_" + r}>
        {accordionIndexOpen === r.toString() ? (
          <td className="cell" colSpan={columns.length}>{accordionContent}</td>
        ) : null}
      </tr>);
    }

    let contentStyleWithHeight = { display: "block", height: bodyHeight, overflow: "auto" };

    return (
      <tbody className="table-content"  style={bodyHeight ? contentStyleWithHeight : null}>
        {dataSource.length > 0 ? (
          arrayRows
        ) : (
          <tr className="row">
            <td className="cell" colSpan={columns.length}>{emptyMessage} </td>
          </tr>
        )}
      </tbody>
    );
  }

  renderHeader(
    columns, filterFunc, additionalProps, selection, bodyHeight, selectedRows
  ) {
    let arrayCeil = [];
    let arrayFilter = [];
    if (selection){
      arrayCeil.push(<th className="cell" key={"cellHeaderTitleSelection"}>
        <Checkbox checked={selectedRows.length > 0 ? this.state.checkAll: false} indeterminate={this.state.checkAllIndeterminate} onChange={this.onCheckAll.bind(this)}></Checkbox>
      </th>);

    }
    for (let c = 0; c < columns.length; c++) {
      arrayCeil.push(<th className="cell" key={"cellHeaderTitle_" + c} style={columns[c].style}>
        {columns[c].title}
      </th>);
      if (columns[c].filter) {
        arrayFilter.push(<th className="cell-filter" key={"cellFilter"}></th>);
        arrayFilter.push(<th className="cell-filter" key={"cellFilter_" + c} style={columns[c].style}>
          {columns[c].filter && columns[c].isFiltrable
            ? columns[c].filter(filterFunc, additionalProps)
            : null}
        </th>);
      }
    }
    return (
      <thead className="table-header" style={{ display: bodyHeight ? "block" : "", height: arrayFilter.length > 0 ? "100%" : "65px"}}>
        <tr>{arrayCeil}</tr>
        <tr style={{ backgroundColor: "#f2f5f8", height: "20px" }}>
          {arrayFilter}
        </tr>
      </thead>
    );
  }

  render(){
    const {
      accordionContent,
      accordionIndexOpen,
      columns,
      dataSource,
      emptyMessage,
      filterFunc,
      additionalProps,
      selection,
      bodyHeight,
      selectedRows
    } = this.props;
    
    return (<table className="table-container">
      {this.renderHeader(
        columns, filterFunc, additionalProps, selection, bodyHeight, selectedRows
      )}
      {this.renderContent(
        accordionContent,
        accordionIndexOpen,
        columns,
        dataSource,
        emptyMessage,
        additionalProps,
        selection,
        bodyHeight,
        selectedRows
      )}
      <tfoot className="table-footer"></tfoot>
    </table>);
  }

}

Table.propTypes = {
  accordionContent: PropTypes.node,
  accordionIndexOpen: PropTypes.string,
  columns: PropTypes.array,
  dataSource: PropTypes.array,
  emptyMessage: PropTypes.string,
  filterFunc: PropTypes.func,
  onSelect: PropTypes.func,
  selection: PropTypes.bool,
  selectedRows: PropTypes.array
};

export default Table;

